import React, { useEffect } from 'react';
import PageHero from './PageHero';
import ContactInfoCards from './ContactInfoCards';
import MapEmbed from './MapEmbed';
import ContactForm from './ContactForm';
import ContactCTAStrip from './ContactCTAStrip';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-page">
      <PageHero title="Contact" />
      <ContactInfoCards />
      <MapEmbed />
      <ContactForm />
      <ContactCTAStrip />
    </div>
  );
};

export default Contact;
